interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Loading({ size = 'md', className = '' }: LoadingProps) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8', 
    lg: 'w-12 h-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div 
        className={`${sizeClasses[size]} border-4 border-gray-200 border-t-purple-500 rounded-full animate-spin`}
        role="status"
        aria-label="Carregando..."
      >
        <span className="sr-only">Carregando...</span>
      </div>
    </div>
  );
}

// Componente de Loading para página inteira
export function PageLoading() {
  return (
    <div className="fixed inset-0 bg-white/80 dark:bg-[#1A1D29]/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          {/* Círculo externo */}
          <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
          {/* Círculo animado */}
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-purple-500 border-r-purple-500 rounded-full animate-spin"></div>
        </div>
        <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">Carregando...</p>
      </div>
    </div>
  );
}

// Componente de Loading circular para transições de página
export function RouteLoading() {
  return (
    <div className="fixed inset-0 bg-black/20 dark:bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 transition-all duration-300">
      <div className="bg-white dark:bg-[#2A2E3F] rounded-2xl p-6 shadow-2xl border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col items-center space-y-3">
          <div className="relative">
            {/* Círculo de fundo */}
            <div className="w-12 h-12 border-3 border-gray-200 dark:border-gray-600 rounded-full opacity-30"></div>
            {/* Círculo animado principal */}
            <div className="absolute top-0 left-0 w-12 h-12 border-3 border-transparent border-t-purple-500 border-r-purple-400 rounded-full animate-spin"></div>
            {/* Círculo animado secundário (sentido contrário) */}
            <div className="absolute top-1 left-1 w-10 h-10 border-2 border-transparent border-b-pink-500 border-l-pink-400 rounded-full animate-spin-reverse"></div>
          </div>
          <p className="text-gray-700 dark:text-gray-300 text-xs font-medium">Carregando página...</p>
        </div>
      </div>
    </div>
  );
}

// Componente de Loading circular compacto para uso geral
export function CircularLoading({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3'
  };

  return (
    <div className="relative inline-block">
      {/* Círculo de fundo */}
      <div className={`${sizeClasses[size]} border-gray-200 dark:border-gray-600 rounded-full opacity-30`}></div>
      {/* Círculo animado */}
      <div className={`absolute top-0 left-0 ${sizeClasses[size]} border-transparent border-t-purple-500 border-r-purple-400 rounded-full animate-spin`}></div>
    </div>
  );
} 